import { Card, CardContent } from "components/ui/card";
import { cn } from "@/lib/utils";
import { ChevronRight } from "lucide-react";
import { useHistory } from "react-router-dom";
import * as Routes from "routes";

interface SecondaryLink {
  label: string;
  href: string;
}

const SECONDARY_LINKS: SecondaryLink[] = [
  { label: "Documentation", href: Routes.docsPage },
  { label: "Subscription", href: Routes.orgSubscription },
  { label: "Demos", href: Routes.demosPage },
  { label: "Usage", href: Routes.developerUsage },
];

export const LinksCard = ({ editing = false }: { editing?: boolean }) => {
  const history = useHistory();

  return (
    <Card className="h-full gap-0 overflow-hidden py-0">
      <div className="border-b px-4 py-2.5 text-[10px] font-medium tracking-wide uppercase text-muted-foreground">
        Also here
      </div>
      <CardContent className="flex min-h-0 flex-1 flex-col px-0">
        {SECONDARY_LINKS.map((link) => (
          <button
            key={link.href}
            type="button"
            disabled={editing}
            data-testid={`home-link-${link.label.toLowerCase().replace(/\W+/g, "-")}`}
            onClick={() => history.push(link.href)}
            className={cn(
              "flex items-center justify-between border-b px-4 py-2 text-left text-sm last:border-b-0",
              !editing && "cursor-pointer hover:bg-muted",
            )}
          >
            {link.label}
            {!editing && (
              <ChevronRight className="size-3.5 shrink-0 text-muted-foreground" />
            )}
          </button>
        ))}
      </CardContent>
    </Card>
  );
};
